<script lang="ts" setup>
import { computed, toRaw } from 'vue';
import IdeoFormCheckbox from './IdeoFormCheckbox.vue';

const model = defineModel<any[]>({
    required: false,
    default: (): any[] => ([])
});
const props = withDefaults(defineProps<{
    checked?: any[],
    valueField?: string,
    textField?: string,
    options?: Record<string, any>[],
    stacked?: boolean,
    columns?: number,
    disabled?: boolean,
    noPadding?: boolean,
    checkboxClass?: any
}>(), {
    checked: undefined,
    valueField: 'value',
    textField: 'text',
    options: (): any => [],
    stacked: false,
    columns: 1,
    disabled: false,
    checkboxClass: ''
});
const emit = defineEmits<{
    (e: 'update:modelValue', value: any): void;
    (e: 'change', value: any, old: any): void;
}>();

const internal = computed(() => props.checked !== undefined ? props.checked : model.value);

const customClass = (): Record<string, boolean> =>
{
    return {
        'd-flex flex-wrap flex-row': props.stacked === false,
        'd-flex flex-wrap flex-column': props.stacked !== false && props.columns == 1,
        [`row row-cols-${props.columns}`]: props.stacked !== false && props.columns > 1
    };
};

const isDisabled = (option: Record<string, any>): boolean =>
{
    if (props.disabled == true)
        return true;

    if ('disabled' in option)
        return option.disabled;

    return false;
};

const onChange = (value: any): void =>
{
    if (props.checked === undefined)
    {
        model.value = value;
    }

    emit('change', value, toRaw(internal.value));
};
</script>

<template>
    <fieldset :class="customClass()" :disabled="disabled">
        <slot name="default">
            <span class="col" v-for="(option, i) in options" :key="i">
                <IdeoFormCheckbox :value="option[valueField]" :disabled="isDisabled(option)" :checked="internal" @change="onChange" :no-padding="noPadding" :class="checkboxClass">
                    <slot name="label" :option="option" :index="i">{{ option[textField] }}</slot>
                </IdeoFormCheckbox>
            </span>
        </slot>
    </fieldset>
</template>
